// extracted by css-extract-rspack-plugin
module.exports =  {"root":"CenteredContent-m__root___dUR7D"};